module.exports = __webpack_public_path__ + "img/logo.48c6d0a7.png";